import { useEffect } from 'react'

import { observer } from 'mobx-react'

import useStore from '@/hooks/useStore'

function ElevationMeasure() {
  const measureStore = useStore('measureStore')
  useEffect(() => {
    init()
    return () => {
      measureStore.clearElevationMeasure()
    }
  }, [])

  const init = () => {
    measureStore.elevationMeasure(window.cviewer)
  }
  return <div></div>
}
export default observer(ElevationMeasure)
